import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import Template from "../../layout/Template";
import { ProfissionaisService } from "../../services/api/Profissionais/ProfissionaisService"
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { faChevronLeft, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProfissionalDados = () => {

    const { idCliente } = useParams()
    const [cliente, setCliente] = useState(null)
    console.log(idCliente)
    useEffect(() => {

        const fetchData = async () => {
            const res = await ProfissionaisService.getById(idCliente)
            console.log(res)
            if (res.success) {
                setCliente(res.data);
            } else {
                setCliente(null)
            }

        }

        fetchData()
    }, [])

    return (

        <>
            <Template>
                <h3 className="text-info"> Profissionais
                    <Button variant="danger" size="sm" style={{ marginLeft: '15px' }} href="/admin/profissionais"><FontAwesomeIcon icon={faChevronLeft} /> Voltar</Button>
                </h3>
                <hr></hr>
                <Container fluid id="cliente-header">
                    <Row>

                    </Row>
                    <Row>
                        <Col>
                            <h4 className="text-default"><span className="mr-10">{cliente?.nome} {cliente?.sobrenome} </span>
                            <Button variant="primary" size="sm" href={'/admin/profissionais/cadEdit/' + idCliente}><FontAwesomeIcon icon={faPenToSquare} /> Editar</Button>

                            </h4>

                        </Col>
                        <Col>
                            <div>
                                <label className="text-default">Observações:</label> {cliente?.obervacoes}
                            </div>
                            <div>
                                <label className="text-default">Alerta:</label> <span className="text-danger"> {cliente?.alerta}</span>
                            </div>
                        </Col>
                    </Row>
                </Container>



            </Template>

        </>


    )
}

export default ProfissionalDados;